import React from "react";
import { useTheme } from "../../../../contexts/ThemeContext";

interface DowngradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  billingDate: string;
}

const DowngradeModal: React.FC<DowngradeModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  billingDate,
}) => {
  const { theme } = useTheme();
  const isDark = theme === "dark";
  if (!isOpen) return null;

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${
        theme === "dark" ? "bg-black/90" : "bg-black/50"
      }`}
    >
      <div
        className={`relative w-full max-w-md rounded-[24px] shadow-[0_30px_80px_rgba(0,0,0,0.85)] border overflow-hidden ${
          theme === "dark"
            ? "bg-[#181818] text-gray-100 border-[#2A2A2A]"
            : "bg-white text-gray-900 border-gray-200"
        }`}
      >
        <button
          onClick={onClose}
          aria-label="Close"
          className={`absolute top-3 right-4 h-8 w-8 flex items-center justify-center rounded-full transition-colors ${
            theme === "dark"
              ? "bg-[#2A2A2A] hover:bg-[#363636] text-gray-300"
              : "bg-gray-100 hover:bg-gray-200 text-gray-600"
          }`}
        >
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13 1L1 13M1 1L13 13"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="px-8 py-10 text-center flex flex-col items-center">
          <div
            className="flex items-center justify-center mb-2"
            style={{
              width: 50,
              height: 50,
              borderRadius: 28,
              border: isDark ? "8px solid #2E2E2E" : "8px solid #E5E7EB",
              background: isDark
                ? "linear-gradient(180deg, #1F1F1F 0%, #2E2E2E 100%)"
                : "linear-gradient(180deg, #F3F4F6 0%, #E5E7EB 100%)",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M20 10C20.5523 10 21 10.4477 21 11V16C21 16.5523 20.5523 17 20 17H15C14.4477 17 14 16.5523 14 16C14 15.4477 14.4477 15 15 15H19V11C19 10.4477 19.4477 10 20 10Z"
                fill="#C6D92C"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L9 11.5858L12.2929 8.29289C12.6834 7.90237 13.3166 7.90237 13.7071 8.29289L20.7071 15.2929C21.0976 15.6834 21.0976 16.3166 20.7071 16.7071C20.3166 17.0976 19.6834 17.0976 19.2929 16.7071L13 10.4142L9.70711 13.7071C9.31658 14.0976 8.68342 14.0976 8.29289 13.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z"
                fill="#C6D92C"
              />
            </svg>
          </div>

          <h3 className="text-xl font-bold mb-3 text-white">
            Downgrade License?
          </h3>

          <p
            className={`text-xs leading-relaxed mb-4 ${
              isDark ? "text-gray-300" : "text-gray-600"
            }`}
          >
            Your invoice will reflect the change on your next billing date
            <span className={isDark ? "text-white" : "text-gray-900"}>
              &nbsp;{billingDate}
            </span>
          </p>

          <div className="flex items-center justify-center gap-4 w-full">
            <button
              type="button"
              onClick={onClose}
              className={`flex-1 px-4 py-3 font-semibold rounded-[12px] border transition-colors ${
                theme === "dark"
                  ? "border-white/10 bg-[#262626] text-white hover:bg-[#2F2F2F]"
                  : "border-gray-300 bg-gray-50 text-gray-900 hover:bg-gray-100"
              }`}
            >
              Maybe later
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className="flex-1 px-4 py-3 font-bold text-white rounded-[12px] border-[1.5px] border-[#C6D92C] bg-[linear-gradient(180deg,#6C7712_0%,#48500C_100%)] shadow-[0_0_0_1px_rgba(0,0,0,0.65)]"
            >
              Downgrade
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DowngradeModal;
